import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

/**
 * Non-blocking, app-wide offline indicator.
 *
 * Shown while the app is loaded but the browser reports no network connection.
 * Unlike the full-page <OfflineNetwork />, this leaves the current view mounted
 * so in-progress work (e.g. an open signing wizard) stays on screen; it simply
 * warns that changes can't be saved until the connection returns.
 */
const OfflineBanner = () => {
  return (
    <div
      role="alert"
      aria-live="assertive"
      data-testid="offline-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 3000,
        backgroundColor: '#e63757',
        color: '#fff',
        textAlign: 'center',
        padding: '0.5rem 1rem',
        fontSize: '0.875rem',
        fontWeight: 500,
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)'
      }}
    >
      <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
      You&apos;re offline. Changes can&apos;t be saved until your connection
      returns.
    </div>
  );
};

export default OfflineBanner;
